<div class="details-container">
    <div class="header">
      <button class="back-btn" routerLink="/admin/fans">
        <i class="fas fa-arrow-left"></i>
        Retour
      </button>
      <h2>Détails du Fan</h2>
    </div>
  
    <ng-container *ngIf="loading">
      <div class="loading">Chargement...</div>
    </ng-container>
  
    <ng-container *ngIf="error">
      <div class="error">{{ error }}</div>
    </ng-container>
  
    <ng-container *ngIf="fan && !loading">
      <div class="content-grid">
        <!-- Informations principales -->
        <div class="card profile-card">
          <div class="profile-header">
            <img [src]="fan.profile_picture || 'assets/images/avatar.jpeg'" alt="Avatar">
            <div class="profile-info">
              <h3>{{ fan.name }}</h3>
              <p class="email">{{ fan.email }}</p>
              <!-- <span class="category">{{ fan?.category }}</span> -->
              <span class="status" [class]="fan.status">{{ fan.status }}</span>
            </div>
          </div>
          <div class="profile-actions">
            <button 
              class="status-btn" 
              [class.activate]="fan.status === 'inactive'"
              [class.deactivate]="fan.status === 'active'"
              (click)="updateStatus(fan.status === 'active' ? 'inactive' : 'active')"
            >
              <i class="fas" [class.fa-check-circle]="fan.status === 'inactive'" [class.fa-ban]="fan.status === 'active'"></i>
              {{ fan.status === 'active' ? 'Désactiver' : 'Activer' }}
            </button>
            <button class="edit-btn">
              <i class="fas fa-edit"></i>
              Modifier
            </button>
          </div>
          <div class="biography">
            <h4>Biographie</h4>
            <!-- <p>{{ fan?.biography }}</p> -->
          </div>
        </div>
      </div>
    </ng-container>
</div>